export enum ETAPE {
    ETP_AIN_CODE = 'ETP_AIN',
    ETP_INS_CODE = 'ETP_INS',
    ETP_CLO_CODE = 'ETP_CLO',
}
